/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import { FormularioExternoSPC } from '../components/form/FormularioExternoSPC.tsx';
import { useAppDispatch, useAppSelector } from '../hooks/typedHooks.ts';
import { getTiposDocs } from '../thunks/getTiposDocsThunk.ts';
import { getReportantes } from '../thunks/getReportantesThunk.ts';
import { getClinicas } from '../thunks/getClinicasThunk.ts';

interface appI{
  llave_recaptcha:string
}

function FormApp({llave_recaptcha}:appI) {

  const dispatch = useAppDispatch();
  const { loadingTiposDocs, tiposDocs } = useAppSelector(state => state.tiposDocs);
  const { loadingReportante, reportantes } = useAppSelector(state => state.reportantes);
  const { loadingClinicas, clinicas } = useAppSelector(state => state.clinicas);

  useEffect(() => {
    dispatch(getTiposDocs());
    dispatch(getReportantes());
    dispatch(getClinicas());
  }, []);
  
  return (
    <div>
      {loadingTiposDocs && loadingClinicas && loadingReportante ?
        'Cargando data...' :
        
        <FormularioExternoSPC tiposDocs={tiposDocs} reportantes={reportantes} clinicas={clinicas} llave_recaptcha={llave_recaptcha}>

        </FormularioExternoSPC>
      }
    </div>
  )
}

export default FormApp;
